import React, { Component } from "react";
import PropTypes from "prop-types";
import "./ShipmentTracking.scss";

type Props = {
    tracking: string;
    service: string;
    isVoided?: boolean;
};

type State = {};

class ShipmentTracking extends Component<Props, State> {
    constructor(props: any) {
        super(props);
    }

    getFedexTracking = () => {
        return (
            <a
                target="_blank"
                href={`https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=${this.props.tracking}&cntry_code=us&locale=en_US`} rel="noreferrer">
                {this.props.tracking}
            </a>
        );
    };

    getUpsTracking = () => {
        return (
            <a target="_blank" href={`https://www.ups.com/track?loc=en_US&tracknum=${this.props.tracking}&requester=WT/`} rel="noreferrer">
                {this.props.tracking}
            </a>
        );
    };

    getUspsTracking = () => {
        return (
            <a target="_blank" href={`https://tools.usps.com/go/TrackConfirmAction?tLabels=${this.props.tracking}`} rel="noreferrer">
                {this.props.tracking}
            </a>
        );
    };

    getTntTracking = () => {
        return (
            <a target="_blank" href={`https://www.tnt.com/express/en_us/site/tracking.html?searchType=con&cons=${this.props.tracking}`} rel="noreferrer">
                {this.props.tracking}
            </a>
        );
    };

    getDhlTracking = () => {
        return (
            <a target="_blank" href={`http://www.dhl.com/en/express/tracking.html?brand=DHL&AWB=${this.props.tracking}`} rel="noreferrer">
                {this.props.tracking}
            </a>
        );
    };

    getTrackingUri = () => {
        let uri;

        switch (this.props.service) {
            case "fedex":
            case "FedEx":
            case "Fedex":
            case "FEDEX":
                uri = this.getFedexTracking();
                break;

            case "ups":
            case "UPS":
            case "Ups":
                uri = this.getUpsTracking();
                break;

            case "usps":
            case "USPS":
            case "Usps":
            case "endicia":
            case "Endicia":
                uri = this.getUspsTracking();
                break;

            case "tnt":
            case "TNT":
            case "Tnt":
                uri = this.getTntTracking();
                break;

            case "dhl":
            case "DHL":
            case "Dhl":
                uri = this.getDhlTracking();
                break;

            default:
                uri = this.props.tracking;
                break;
        }

        return uri;
    };

    render() {
        return (
            <div className="ShipmentTracking">
                {this.props.isVoided ? <div className={"text-strikethrough text-muted"}>{this.props.tracking}</div> : this.getTrackingUri()}
            </div>
        );
    }
}

export default ShipmentTracking;
